import { render, staticRenderFns } from "./PowerupViewComponent.vue?vue&type=template&id=220d7821&scoped=true"
import script from "./PowerupViewComponent.vue?vue&type=script&lang=js"
export * from "./PowerupViewComponent.vue?vue&type=script&lang=js"
import style0 from "./PowerupViewComponent.vue?vue&type=style&index=0&id=220d7821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d7821",
  null
  
)

export default component.exports